{
  "version": 1,
  "asset_id": "19d27d5b-cc0c-46c1-9c44-40f3b7020714",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/19d27d5b-cc0c-46c1-9c44-40f3b7020714/palworld-sleeves.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/19d27d5b-cc0c-46c1-9c44-40f3b7020714/palworld-sleeves.webp",
  "original_filename": "palworld-sleeves.webp",
  "size": 115912,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:36:22Z"
}
